<template>
    <div v-if="client">
        <!-- deposit by pin -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Pin deposit</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.paymentSystemSettings.pinDepositAllowed"
                                   type="checkbox" />
                            allowed
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- withdrawal by pin -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Pin withdrawal</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.paymentSystemSettings.pinWithdrawalAllowed"
                                   type="checkbox" />
                            allowed
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- withdrawal by cashout -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">CashOut withdrawal (kiosks)</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.paymentSystemSettings.cashOutWithdrawalAllowed"
                                   type="checkbox" />
                            allowed
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- withdrawal by cashier -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Cashier withdrawal (kiosks)</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.paymentSystemSettings.cashierWithdrawalAllowed"
                                   type="checkbox" />
                            allowed
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- payment system deposit -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Payment system deposit</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.paymentSystemSettings.paymentSystemDepositAllowed"
                                   type="checkbox" />
                            allowed
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- payment system withdrawal -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Payment system withdrawal</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.paymentSystemSettings.paymentSystemWithdrawalAllowed"
                                   type="checkbox" />
                            allowed
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Skip withdrawal approval</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.paymentSystemSettings.skipWithdrawalApproval" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- payment system login -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Payment system login</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="client.settings.paymentSystemSettings.paymentSystemLogin"
                               class="input oc-input"
                               type="text" />
                    </p>
                </div>
            </div>
        </div>

        <!-- mpesa paybill allowed -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">MPesa paybill allowed</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.paymentSystemSettings.mPesaPaybillAllowed"
                                   type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- mpesa paybill number -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">MPesa paybill number</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="client.settings.paymentSystemSettings.mPesaPaybillNumber"
                            :disabled="!client.settings.paymentSystemSettings.mPesaPaybillAllowed"
                            class="input oc-input"
                            type="text" />
                    </p>
                </div>
            </div>
        </div>
    
        <!-- payment method selector enabled -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Payment Method Selector Enabled</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.paymentSystemSettings.paymentMethodSelectorEnabled" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- payment method selector -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Payment Method Selector</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="client.settings.paymentSystemSettings.paymentMethodSelector"
                            :disabled="!client.settings.paymentSystemSettings.paymentMethodSelectorEnabled"
                            class="input oc-input"
                            type="text" />
                    </p>
                </div>
            </div>
        </div>
    
        <!-- new operations expiration enabled -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">New Operations Expiration Enabled</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.paymentSystemSettings.newOperationsExpirationEnabled" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <!-- new operations expiration seconds -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">New Operations Expiration Seconds</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="client.settings.paymentSystemSettings.newOperationsExpirationSeconds"
                            :disabled="!client.settings.paymentSystemSettings.newOperationsExpirationEnabled"
                            class="input oc-input"
                            type="number" />
                    </p>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import state from '../../../../state';
import utils from '../../../../utils';
import clientService from '../../../../services/client.service';

export default {
    name: 'client-settings-payment-system',
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        currencies() {
            return state.currencies.get();
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save() {
            await clientService.save(this.client);
        }
    }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/payment-system.vue